<app-carousel [enableControlsOffset]="!isMobile">
  <ng-template carouselItem="1">
    <mat-card appearance="outlined" class="mat-card-c">
      <mat-card-content class="mat-body-1">
        <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
      </mat-card-content>
    </mat-card>
  </ng-template>

  @if (workOrderDetails.workOrderId) {
    <ng-template carouselItem="2">
      <mat-card appearance="outlined" class="mat-card-c">
        <mat-card-content class="mat-body-1">
          <h2 style="display: flex; justify-content: center">
            <strong>ANEXOS</strong>
          </h2>
          <div>
            @if (!imageSrc && !imageSrc2 && !imageSrc3) {
              <h3
                style="display: flex; justify-content: center"
                >
                No hay imágenes asociadas a esta orden de trabajo
              </h3>
            }
          </div>
          <div class="containerPhotos">
            @if (imageSrc) {
              <div class="photo">
                <img
                  class="mat-elevation-z8"
                  src="{{ imageSrc }}"
                  [ngStyle]="sizePicture"
                  />
              </div>
            }
            @if (imageSrc2) {
              <div class="photo">
                <img
                  class="mat-elevation-z8"
                  src="{{ imageSrc2 }}"
                  [ngStyle]="sizePicture"
                  />
              </div>
            }
            @if (imageSrc3) {
              <div class="photo">
                <img
                  class="mat-elevation-z8"
                  src="{{ imageSrc3 }}"
                  [ngStyle]="sizePicture"
                  />
              </div>
            }
          </div>
        </mat-card-content>
      </mat-card>
    </ng-template>
  }

  @if (inventoryModule && resources.length > 0) {
    <ng-template carouselItem="3">
      <mat-card appearance="outlined" class="mat-card-c">
        <mat-card-content class="mat-body-1">
          <h2 style="display: flex; justify-content: center">
            <strong>RECURSOS</strong>
          </h2>
          <data-table
            [title]="''"
            [columns]="columnsResouces"
            [configuration]="configurationResouces"
            [url]="urlGetTableResources"
            [params]="paramsResources"
            (internalData)="dataResources($event)"
            >
          </data-table>
        </mat-card-content>
      </mat-card>
    </ng-template>
  }

  <ng-template carouselItem="4">
    <mat-card appearance="outlined" class="mat-card-c">
      <mat-card-content class="mat-body-1">
        <data-table
          [title]="titleC"
          [columns]="columnsComments"
          [configuration]="configurationComments"
          [reloadTable]="reloadComments"
          [url]="EndpointDictionary.WorkOrder.COMMENTS.TABLE"
          [params]="paramsComments"
          (fileIconClick)="onFileIconClick($event)"
          >
        </data-table>
      </mat-card-content>
    </mat-card>
  </ng-template>
</app-carousel>

<!-- <ng-template #matDescription>
<mat-card class="mat-card-c">
  <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
</mat-card>
</ng-template> -->

<ng-template #descriptionTemplate>
  <h2>
    <strong>Equipo: {{ data.code }} </strong>
  </h2>
  <h3>Número de orden: {{ data.consecutive }}</h3>
  <h3>Medidor actual (horas/km/ciclos): {{ data.odometer | thousandSeparator }}</h3>
  <h3>Referencia Factura: {{ data.invoiceReference }}</h3>
  <h3>Tipo de mantenimiento: {{ data.maintenanceType }}</h3>
  <h3>Tiempo estimado: {{ data.estimatedTime }} horas</h3>
  @if (data.finalTime) {
    <h3>Tiempo real de ejecucion: {{ data.finalTime }} horas</h3>
  }
  <h3>Descripción: {{ data.description }}</h3>
  <h3>Responsable: {{ data.responsible }}</h3>
  <h3>Fecha ejecucion: {{ data.executionDate }}</h3>
  @if (data.resources) {
    <h3>Recursos: {{ data.resources }}</h3>
  }
  <h3>
    Costo Mantenimiento:
    {{
    (data.finalCost == null || data.finalCost == 0
    ? data.cost
    : data.finalCost
    ) | thousandSeparator
    }}
  </h3>
  @if (inventoryModule) {
    <h3>
      Costo Recursos: {{ totalCostItems | thousandSeparator }}
    </h3>
  }
  @if (inventoryModule) {
    <h3>
      Costo Total:
      {{
      totalCostItems +
      (data.finalCost == null || data.finalCost == 0
      ? (data.cost ? +data.cost : 0)
      : data.finalCost) | thousandSeparator
      }}
    </h3>
  }
  <h3>Observaciones: {{ data.observations }}</h3>
  <hr />
  <h2>Autorizó: {{ data.authorizesName }}</h2>
  <hr />
  @if (bodyUsuarios.length > 0) {
    <h3>
      {{
      workOrderDetails.workOrderId
      ? 'El Mtto lo realizó un: ' + bodyUsuarios[0].responsibleType
      : 'El Mtto lo realizará un: ' + bodyUsuarios[0].responsibleType
      }}
    </h3>
  }
  @for (item of bodyUsuarios; track item) {
    <div>
      <h3>Encargado: {{ item.name }}</h3>
    </div>
  }
</ng-template>
